import React from 'react';

const HomeIcon = (props) => {
    return (
        <svg width="16px" height="18px" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.356 4.944A.8.8 0 000 5.61V17.2a.8.8 0 00.8.8h4.8v-5.748a.8.8 0 01.8-.8h3.2a.8.8 0 01.8.8V18h4.8a.8.8 0 00.8-.8V5.61a.8.8 0 00-.356-.666L8.444.138a.8.8 0 00-.888 0l-7.2 4.806z"
                fill="#1D1D1D"
            />
        </svg>
    )
}

export default HomeIcon;
